import { styled } from '@mui/material/styles';

export const StyledVoiceCard = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px 24px 24px;
  border-radius: 16px;
  border: 0.5px solid #1e164e14;
  width: 100%;
  min-width: 488px;
  max-width: calc(50% - 8px);
  height: 100%;
  box-sizing: border-box;
  flex: 1 1 0;
  box-shadow: 0px 4px 16px 0px #00000014;

  @media only screen and (max-width: 1380px) {
    min-width: 100%;
    padding: 16px;
  }
`;

export const StyledListVoiceCard = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  padding: 0px 24px 24px 24px;
  box-sizing: border-box;
`;

export const StyledVoiceCardHeader = styled('div')`
  display: flex;
  align-items: center;
  .MuiAvatar-root {
    border-radius: 50% !important;
  }
  .voice-card-avatar {
    margin-right: 16px;
  }
  .verified-icon {
    width: 24px;
    height: 24px;
  }
  .voice-card-header-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const StyledVoiceCardContent = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  .voice-card-content-item-info {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .voice-card-content-item {
    width: 212px;
    max-width: 100%;
    gap: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 8px;
    padding: 12px;
    background-color: #f4f5f7a3;
    @media only screen and (max-width: 1380px) {
      flex: 1;
    }
  }
`;
